import { CompanyEntity } from '../common/entity';

export class BinConstraint extends CompanyEntity {
  stockLocationId!: string;
  pmdId!: string;
  binId!: string;

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    Object.assign(this, obj);
  }
}
